export default "__VITE_ASSET__C07Pk5D0__"